function whereNextSwitcher() {
    const dropdown = document.querySelector('#dropdown');
    const results = document.querySelectorAll('.value-target');

    // log the dropdown and results
    //console.log(results);

    // Hide all results
    results?.forEach(result => result.classList.add('not-visible'));

    // Show the first result
    results[0]?.classList.remove('not-visible');

    // Detect a change on the select dropdown
    dropdown?.addEventListener('change', function () {
        const selectedOption = this.value;
        //console.log(selectedOption);

        // Find the corresponding result element
        const displayedOption = (Array.from(results).find(result => result.getAttribute('value-target') === selectedOption) || {}).getAttribute('value-target') || null;

        // Hide all results
        results.forEach(result => result.classList.add('not-visible'));

        // Show the selected result
        document.querySelector(`[value-target="${displayedOption}"]`).classList.remove('not-visible');

    });
}

export default whereNextSwitcher;